var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrolley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 682.67 682.67",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 512h512v-512h-512z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 512h512v-512h-512z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 682.67)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(198.74 408.22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-191.24",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504.5 408.22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-191.24",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(313.26 484.49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h191.24",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.5 484.49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h191.24",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(263.65 504.49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h49.609v-114.53h-114.52v114.53h30.261",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.5 452.61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 40.585-44.388 69.729 76.264 69.729-76.264",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504.5 452.61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-40.585-44.388-69.729 76.264-69.729-76.264",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(491,7.4878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v208.51",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 131.43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v-123.95",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v-49.998",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155.45 216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 85.091 51.798",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(356.55 216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-85.091 51.798",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(273.78 277.04)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0-9.821-7.962-17.783-17.783-17.783s-17.782 7.962-17.782 17.783 7.961 17.783 17.782 17.783 17.783-7.962 17.783-17.783z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(233.48 317.34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0-12.436 10.081-22.517 22.516-22.517 12.436 0 22.517 10.081 22.517 22.517s-10.081 22.517-22.517 22.517v50.1",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.5 216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h497",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(410.22 7.4878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h94.283",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.5,7.4878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h368.24",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(300.88 176.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v-129.84",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(256 176.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v-129.84",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(211.12 65.826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v-18.92",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(211.12 176.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v-75.746",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(166.23 176.58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v-129.84",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(121.35 176.41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v-129.84",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.461 176.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v-129.84",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(345.77 176.58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v-129.84",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(390.65 176.41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v-129.84",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(435.54 176.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v-129.84",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(229 421.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v0",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(229 473.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v0",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(283 421.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v0",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(283 473.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v0",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrolley);
export default __webpack_public_path__ + "static/media/trolley.9cc9508a684a449b48f8537611871b64.svg";
export { ForwardRef as ReactComponent };